import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseMiscDomainService } from '@common/domain/base-misc-domain.service';

import { AssetMiscApiService } from '../api/asset-misc-api.service';
import { EnrichedAssetApi } from '../api/models';
import { UpsertAssetViewModel } from '../models';
import { EnrichedAsset } from '../models/asset';

@Injectable({
    providedIn: 'root'
})
export class AssetMiscDomainService extends BaseMiscDomainService
{
    constructor (private assetMiscApiService: AssetMiscApiService)
    {
        super();
    }

    // getAll (type: string): Observable<Map<string, EnrichedAsset>>
    // {
    //     const dico: Map<string, EnrichedAsset> = new Map<string, EnrichedAsset>();

    //     return this.assetMiscApiService.getAll(type)
    //         .pipe(
    //             map((result: EnrichedAssetApi[]) =>
    //             {
    //                 result.forEach((source: EnrichedAssetApi) =>
    //                 {
    //                     const target = new EnrichedAsset();
    //                     Object.assign(target, source);
    //                     dico.set(source.identifier, target);
    //                 });

    //                 return dico;
    //             })
    //         );
    // }

    getAll (type: string): Observable<EnrichedAssetApi[]>
    {
        return this.assetMiscApiService.getAll(type);
    }

    attachTag (typeName: string, identifier: string, name: string, tagId: string): Observable<EnrichedAsset>
    {
        const upsertAssetViewModel: UpsertAssetViewModel = new UpsertAssetViewModel(typeName, name, tagId);

        return this.assetMiscApiService.attachTag(identifier, upsertAssetViewModel)
            .pipe(
                map(EnrichedAsset.mapperFromApi)
            );
    }

    detachTag (typeName: string, identifier: string, tagId: string): Observable<EnrichedAsset>
    {
        return this.assetMiscApiService.detachTag(typeName, identifier, tagId)
            .pipe(
                map(EnrichedAsset.mapperFromApi)
            );
    }
}
